import React from 'react'
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';

const NavLinks = () => {

    const GeneralTranslations = useSelector((state) => state.WebsiteLanguage.data.GeneralTranslations);
    const ControlsTranslations = useSelector((state) => state.WebsiteLanguage.data.ControlsTranslations);

    return (
        <ul className="nav-links-list">
            <NavLink to="/">
                {GeneralTranslations.report}
            </NavLink>
            <NavLink to="/Kerko">
                {ControlsTranslations.SearchButton}
            </NavLink>
        </ul>
    )
}

export default NavLinks